import { render, staticRenderFns } from "./ChildCharacters.vue?vue&type=template&id=7f317b20&"
import script from "./ChildCharacters.vue?vue&type=script&lang=js&"
export * from "./ChildCharacters.vue?vue&type=script&lang=js&"
import style0 from "./ChildCharacters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports